// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tech-preview[data-v-227a891e] {\n  font-size: 8px;\n  color: #2f99a3;\n  border: 1px solid #2f99a3;\n  border-radius: 4px;\n  padding: 3px;\n  font-weight: 500;\n}", ""]);
// Exports
module.exports = exports;
